import React, {Component} from 'react';
import PropTypes from "prop-types";

import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import Table from "react-bootstrap/Table";
import Alert from "react-bootstrap/Alert";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {isFalse, isTrue} from '@uw-it-sis/lib-react/lib/Utils';
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";

import {buildRegistrationSlnList, buildRegistrationUrl} from '@uw-it-sis/lib-react-myplan/lib/RegistrationUtils';

import registrationDetailsStore from './RegistrationDetailsStore';

class RegistrationFailure extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            showModal: false,
            sentSpsReg: false,
        }

        this.readyList = registrationDetailsStore.getRegistrationItems();
        this.termId = registrationDetailsStore.getLoadedTerm();
    }

    openModal = () => this.setState({showModal: true})

    closeModal = () => {
        this.setState({showModal: false});
        this.props.onClose();
    }
    // set the show modal to true if the current component usage is not within a modal
    triggerSPSReg = () => this.setState({sentSpsReg: true, showModal: isFalse(this.props.isWithinModal)})

    _findSelectedCourses = () => {
        let selectedCourses = [];

        this.readyList.map(course => {
            if (isTrue(course['sendToRegistration'])) {
                selectedCourses.push(course);
            }
        });

        return selectedCourses;
    }

    _calculateUrl = () => {
        let selectedCourses = this._findSelectedCourses();
        let slns = buildRegistrationSlnList(selectedCourses);
        let slnsToEntryCodes = {};

        this.readyList.map(course => {
            course.planActivities.map(activity => {
                let sln = activity['registrationCode'];
                slnsToEntryCodes[sln] = activity['entryCode'];
            });
        });

        let baseRegUrl = appStore.getAppAttribute('sdb_registration_url');

        return buildRegistrationUrl(baseRegUrl, appStore.getStudentSystemKey(),
            this.termId, slns, slnsToEntryCodes, "mp_reg_preview");
    }

    _buildSpsResult = () => {
        let sectionsTableList = [];
        registrationDetailsStore.getRegistrationItems().map(course => {
            if (course.sendToRegistration) {
                course.planActivities.map(function (section) {
                    let activityId = section.activityId.split(":");
                    let tempSection = {
                        courseSectionCode: `${activityId[2]} ${activityId[3]} ${activityId[4]}`,
                        registrationCode: section.registrationCode,
                        blockChildren: []
                    };
                    // Check to see if this is a block reg parent
                    if ( section.blockRegistration && section.blockRegistration.parent ) {
                        // add data to the model for showing the children of the block (excluding the parent)
                        tempSection.blockChildren = section.blockRegistration.courses.filter(course => !course.parent).map(course => course.label);
                    }

                    sectionsTableList.push(tempSection)
                });
            }
        });

        let sqvUrl = "/plan/#/" + TermUtils.makeTermLinkIdentifierFromTermId(this.termId);

        return (
            <>
                <p>The following sections have been sent to Registration in a new tab:</p>
                <Table>
                    <thead>
                        <tr>
                            <th>Section</th>
                            <th>SLN</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {sectionsTableList.map(function (row, i) {
                            return (
                                <tr key={i}>
                                    <td>{row.courseSectionCode}</td>
                                    <td>{row.registrationCode}</td>
                                    <td>
                                        {row.blockChildren.length > 0 ? "Includes " + row.blockChildren.join(", ") : null}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <p>If your registration was successful, you'll see your updated schedule when you close this window.</p>
                <p>If your registration was unsuccessful, try one of the following steps:</p>
                <ul>
                    <li>Return to the Registration tab to see which errors need to be resolved</li>
                    <li><a href={sqvUrl}>Edit your plan</a> to change the sections that weren't accepted</li>
                    <li>Send to Registration again from this page</li>
                </ul>
            </>
        )
    }

    _buildErrorDisplay = () => {
        let spsRegUrl = this._calculateUrl();

        if (this.props.isGetRegState) {
            return (
                <Alert variant="danger">
                    <Alert.Heading as="h4">Connection Error</Alert.Heading>
                    <p>MyPlan is temporarily unable to determine your pre-registration readiness status.</p>
                    <p>Try again later, or <a href={spsRegUrl} onClick={this.triggerSPSReg} target="_blank">go to the
                        Registration system</a> to find out if you have pre-registration steps to complete.
                    </p>
                </Alert>
            )
        } else {
            return (
                <Alert variant="danger">
                    <Alert.Heading as="h4">Something Went Wrong</Alert.Heading>
                    <p>MyPlan had a temporary connection error.</p>
                    <p>Please retry your task in the <a href={spsRegUrl} onClick={this.triggerSPSReg} target="_blank">Registration system</a>.
                    </p>
                </Alert>
            )
        }

    }

    _buildSpsResultModal = () => {
        return (
            <Modal
                show={this.state.showModal}
                onHide={this.closeModal}
                size="lg"
                aria-labelledby="modal-reg-failure-title"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id="modal-reg-failure-title">Your selected course sections have been sent to Registration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this._buildSpsResult()}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.closeModal}>Close and Refresh</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    render() {
        if (this.props.isWithinModal) {
            if ( isFalse(this.state.sentSpsReg) ) {
                return this._buildErrorDisplay();
            } else {
                return this._buildSpsResult();
            }
        } else {
            return (
                <>
                    {this._buildErrorDisplay()}
                    {this._buildSpsResultModal()}
                </>
            )
        }
    }
}

RegistrationFailure.propTypes = {
    isWithinModal: PropTypes.bool,
    isGetRegState: PropTypes.bool,
    onClose: PropTypes.func
}

RegistrationFailure.defaultProps = {
    isWithinModal: false,
    isGetRegState: false,
    onClose: () => {}
}

export default RegistrationFailure;